import React from 'react';

const SvgCloseDrawer = props => (
  <svg width={26} height={28} {...props}>
    <defs>
      <style>
        {
          '.close_drawer_svg__a{fill:none;stroke:#acacac;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}'
        }
      </style>
    </defs>
    <path
      className="close_drawer__a"
      style={{ stroke: props.color, fill: 'none' }}
      d="M25 14H5M10 9l-5 5 5 5M1 1v26"
    />
  </svg>
);

export default SvgCloseDrawer;
